import React, { useEffect, useState } from "react";
import Link from "next/link";
import { Textbox } from "@mecha/design-components/dist/src/components/Elements/Textbox";
import { Button } from "@mecha/design-components/dist/src/components/Elements/Button";
import CautiousIcon from "../../../assets/svg/CautiousIcon";
import Logger from "../../../libs/Logger";
import GithubIconSvg from "../../../assets/svg/GithubIconSvg";
import { ory } from "../../../libs/auth/sdk/client";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import ExclamationSquareIcon from "../../../assets/svg/ExclamationSquareIcon";
import ExclamationCircleIcon from "../../../assets/svg/ExclamationCircleIcon";

const PrivilegeLogin = ({ flowData, onSubmit }) => {
  const log = new Logger({
    module: "Authentication",
    component: "PrivilegeLogin",
  });
  const [commonErrors, setCommonErrors] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showGithub, setShowGithub] = useState(false);
  const [error, setError] = useState("");
  const getErrorsFromFlowData = () => {
    const errorMessage = [];
    flowData?.ui?.nodes.forEach(element => {
      if (element.messages.length > 0) {
        element.messages.forEach(msg => {
          if (msg.text) {
            errorMessage.push(msg.text);
          }
        });
      }
    });
    setError(errorMessage.join("/n"));
  };

  const identifier = flowData?.ui?.nodes.find(node => {
    if (node.group === "default" && node.attributes.name == "identifier") {
      return node;
    }
  })?.attributes.value;

  useEffect(() => {
    getErrorsFromFlowData();

    const messageText = flowData?.ui?.messages
      ?.filter(e => e.id != 1010003)
      .map(e => {
        if (e.id == 4000006) {
          if (password) setError("The provided password is invalid");
          return "";
        }
        return e.text;
      })
      .join("/n")
      .replace(", or phone number", "");
    if (messageText) {
      setCommonErrors(messageText);
    }

    log.debug({ identifier }, "(useEffect[]) - user email id");
  }, [flowData?.ui]);

  useEffect(() => {
    ory.createBrowserSettingsFlow().then(({ data }) => {
      console.log("setting data", data);
      const socialLogin = data?.ui?.nodes.filter(
        (node: any) =>
          node?.group === "oidc" &&
          node?.attributes?.name === "unlink" &&
          node?.attributes?.value === "github",
      );
      if (socialLogin.length) {
        setShowGithub(true);
      }
    });
  });

  const handleSignIn = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!password) {
      setError("Please enter password");
      return;
    }
    setError("");
    const csrf = flowData?.ui?.nodes.find(node => {
      if (node.group === "default" && node.attributes.name == "csrf_token") {
        return node.attributes.value;
      }
    });

    setLoading(true);

    onSubmit({
      identifier: identifier,
      method: "password",
      csrf_token: csrf.attributes.value,
      password: password,
    });

    setLoading(false);
  };

  const submitGithubForm = e => {
    e.preventDefault();
    setError("");
    const csrf = flowData?.ui?.nodes.find(node => {
      if (node.group === "default" && node.attributes.name == "csrf_token") {
        return node;
      }
    });

    setLoading(true);

    onSubmit({
      provider: "github",
      csrf_token: csrf.attributes.value,
    });

    setLoading(false);
  };
  const passwordNode = flowData?.ui?.nodes.find(node => {
    if (node.group === "password") {
      return node;
    }
  });
  const githubNode = flowData?.ui?.nodes.find(node => {
    if (node.group === "oidc" && node.attributes.value == "github") {
      return node;
    }
  });
  return (
    <div className="flex lg:w-96 w-80 justify-center items-center flex-col mt-2">
      <div className="text-center text-base text-custom-400 dark:text-custom-300">
        You are entering Privilege mode. You will be asked to re-enter the
        credentials only when you are performing sensitive actions
      </div>
      <div className="w-80 lg:w-96 mt-6 ">
        <div className="lg:max-w-sm">
          <form>
            {identifier && (
              <div className="border border-custom-500 dark:border-custom-700 rounded-lg h-10 gap-2  px-3 w-full flex items-center">
                <div className="rounded-md w-6 h-6 bg-custom-600 flex justify-center items-center text-xl text-white">
                  {identifier?.charAt(0)}
                </div>
                <div
                  className="text-base text-neutral-900 dark:text-white font-normal truncate"
                  title={identifier}
                >
                  {identifier?.substring(0, 30)}
                  {identifier?.length > 30 ? "..." : ""}
                </div>
              </div>
            )}
            {commonErrors && (
              <div className="w-full h-full py-4 px-3 rounded-md dark:bg-dark-r-520 bg-light-r-520 flex flex-row gap-2 items-start">
                <ExclamationSquareIcon className="dark:text-dark-r-500 text-light-r-500  w-2 h-2" />
                <p className="text-sm dark:text-dark-n-200 text-light-n-200 __element-common-error-message ">
                  {commonErrors}
                </p>
              </div>
            )}

            {passwordNode && (
              <>
                <div className="relative mt-5 w-full">
                  <Textbox
                    boxSize="m"
                    placeholder="Password"
                    name="password"
                    onChange={e => {
                      if (!e.target.value) {
                        setError("Please enter password");
                      }
                      setPassword(e.target.value);
                    }}
                    className="__input-password-textbox mt-1 "
                    style={error ? { borderColor: "#F4333F" } : {}}
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    rightIcon={
                      showPassword ? (
                        <a
                          className="py-2 w-auto px-2 z-999 __link-password-show"
                          onKeyPress={() =>
                            setShowPassword(prevState => !prevState)
                          }
                          onClick={() =>
                            setShowPassword(prevState => !prevState)
                          }
                        >
                          <img src="/show_pass.svg" alt="show-pass" />
                        </a>
                      ) : (
                        <a
                          className="py-2 w-auto px-2 z-999 __link-password-hide"
                          onKeyPress={() =>
                            setShowPassword(prevState => !prevState)
                          }
                          onClick={() =>
                            setShowPassword(prevState => !prevState)
                          }
                        >
                          <img src="/hide_pass.svg" alt="hide-pass" />
                        </a>
                      )
                    }
                  />

                  {error && (
                    <div className="flex flex-row gap-1 items-center mt-1">
                      <span className=" dark:text-black text-storm-dust-110">
                        <ExclamationCircleIcon
                          className="h-3 w-3 dark:text-bg-dark-r-500 text-light-r-500"
                          fill="transparent"
                        />
                      </span>
                      <span>
                        <p className="text-web-b6 dark:text-dark-n-400 text-light-400 __input-error-password-not-same">
                          {error}
                        </p>
                      </span>
                    </div>
                  )}
                </div>
                <div className="mt-10">
                  <Button
                    type="submit"
                    color="primary"
                    size="m"
                    fullWidth
                    className="__button-sign-in-process"
                    onClick={(e: any) => {
                      handleSignIn(e);
                    }}
                    isLoading={loading}
                  >
                    Confirm
                  </Button>
                </div>
              </>
            )}

            {((githubNode && showGithub) || !passwordNode) && (
              <div className="group flex justify-center mt-5">
                <Button
                  color="default"
                  type="submit"
                  value="github"
                  name="provider"
                  size="m"
                  fullWidth
                  onClick={submitGithubForm}
                >
                  <span className="inline-flex items-center">
                    <GithubIconSvg className="mr-2" />
                    Sign in with GitHub
                  </span>
                </Button>
              </div>
            )}
          </form>
          <div className="flex items-center justify-center mt-5">
            <Link
              href={"/settings/my-account"}
              className="__link-back-to-settings dark:text-dark-n-200 text-ligth-n-200 font-medium flex flex-row items-center gap-1"
            >
              <ArrowLeftIcon
                height={18}
                width={18}
                className="text-neutral-110 dark:text-storm-dust-100 __navigate-signin"
              />
              <p>Back to settings</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PrivilegeLogin;
